import React from 'react';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Signature from './components/Signature';

function App() {
  return (
    <div className="App">
      <Header/>
      <Signature/>
      <Home/>
    </div>
  );
}

export default App;
